import { getOrderFulfillmentCTA } from "./shared";
export var AddressAndPhoneNumber = function AddressAndPhoneNumber(strictLocalize) {
  return {
    titleBuilder: function titleBuilder() {
      return reimbursementOfShippingCostBuilder(strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder() {
      return reimbursementOfShippingCostBuilder(strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getOrderFulfillmentC;
        return (_getOrderFulfillmentC = getOrderFulfillmentCTA(context, strictLocalize)) === null || _getOrderFulfillmentC === void 0 ? void 0 : _getOrderFulfillmentC.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getOrderFulfillmentC2, _getOrderFulfillmentC3;
        return (_getOrderFulfillmentC2 = getOrderFulfillmentCTA(context, strictLocalize)) === null || _getOrderFulfillmentC2 === void 0 ? void 0 : (_getOrderFulfillmentC3 = _getOrderFulfillmentC2.getLink) === null || _getOrderFulfillmentC3 === void 0 ? void 0 : _getOrderFulfillmentC3.call(_getOrderFulfillmentC2);
      }
    }
  };
};
var reimbursementOfShippingCostBuilder = function reimbursementOfShippingCostBuilder(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "uNzg15",
        defaultMessage: [{
          "type": 0,
          "value": "Atualize o número de telefone na sua página de processamento da encomenda"
        }]
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "1f8FkR",
        defaultMessage: [{
          "type": 0,
          "value": "Dependendo do seu problema e do estado do seu envio, poderá ter ainda a possibilidade de corrigir o endereço ou o número de telefone durante o processamento de encomenda. Pode editar o endereço de envio da encomenda no \"Passo 2. Envio a partir do endereço\" da página de processamento de encomenda."
        }]
      }), strictLocalize({
        id: "xnaL/E",
        defaultMessage: [{
          "type": 0,
          "value": "Por vezes, pode tratar-se de um erro ao escrevê-lo ou um espaço que não deveria existir. Se o endereço do revendedor for inválido, pode enviar uma mensagem ou um e-mail diretamente ao revendedor, acedendo à respetiva página do cliente. Se os problemas persistirem, contacte-nos."
        }]
      })];
    }
  };
};